export default function Image({ image, size = "large", ...props }) {
    if (!image) return null;

    if (!(size in image)) {
        if (!("large" in image)) return null;
        size = "large";
    }

    return <img alt={image.alt} src={image[size]} {...props} />;
}
